import {ChangeDetectionStrategy, Component, input, OnDestroy, output, signal} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {QueryBlockFilter} from '../../../models/query-block';
import {ResearchKeywordDTO} from '../../../dto/research-keywords';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

@Component({
  selector: 'app-search-query-keyword',
  imports: [
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule, MatSelectModule, FormsModule, ReactiveFormsModule
  ],
  templateUrl: './search-query-keyword.component.html',
  styleUrl: './search-query-keyword.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchQueryKeywordComponent implements OnDestroy {
  filterInput = input<QueryBlockFilter | undefined>(undefined);
  keyword = input.required<ResearchKeywordDTO>();
  showDelete = input<boolean>(true);
  transparent = input<boolean>(true);
  deleteKeyword = output<void>();
  filterChange = output<QueryBlockFilter>();

  protected readonly QueryBlockFilter = QueryBlockFilter;

  filterList: string[] = [QueryBlockFilter.None, QueryBlockFilter.All, QueryBlockFilter.MESH, QueryBlockFilter.TITLE_ABSTRACT];


  private timeoutId: number | null = null;

  showSynonyms = signal<boolean>(false);

  ngOnDestroy(): void {
    this.clearTimeout();
  }

  toggleSynonyms(event: MouseEvent): void {
    event.stopPropagation();

    if (this.showSynonyms()) {
      this.showSynonyms.set(false);
      this.clearTimeout();
    } else {
      this.showSynonyms.set(true);
      //this.setHideTimeout();
    }
  }

  private setHideTimeout(): void {
    this.clearTimeout();
    this.timeoutId = window.setTimeout(() => {
      this.showSynonyms.set(false);
    }, 5000);
  }

  private clearTimeout(): void {
    if (this.timeoutId !== null) {
      window.clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }


}
